import { render, staticRenderFns } from "./ProjectHoldbacks.vue?vue&type=template&id=287bbb86"
import script from "./ProjectHoldbacks.vue?vue&type=script&lang=js"
export * from "./ProjectHoldbacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports